import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const Main = ({default_value, value, show_inline_warning, onChange}) => {
  const [invoice_date, setInvoiceDate] = useState(value?.value);
  const [show_warning, setShowWarning] = useState(false);
  const [warning_message, setWarningMessage] = useState(null);

  useEffect(() => {
    if(default_value) {
      doSetInvoiceDate(default_value)
    }
  }, [])

  useEffect(() => {
    onBlurInvoiceDate()
  }, [invoice_date])

  const triggerOnChange = (date) => {
    if(onChange) {
      onChange({value: date})
    }
  }

  const doSetInvoiceDate = (date) => {
    setInvoiceDate(date)
    triggerOnChange(date)
  }

  const onChangeInvoiceDate = (date) => {
    doSetInvoiceDate(date ? moment(date).format('MM/DD/YYYY') : null);
  }

  const onChangeRaw = (value) => {
    if(value === undefined) {
      return false
    }

    var parsed_date = moment(value)

    if( !value.split("/")[2] ) {
      if( value.split("/")[1] ) {
        parsed_date.year(moment().year())
      } else if(value.split("/")[0]) {
        var current_day = moment()

        if(value.length == 3) {
          parsed_date = lastMonthDate(moment(`${current_day.year()}-${value.substr(0,2)}-${value.substr(1,2)}`))
        } else if(value.length == 4) {
          parsed_date = lastMonthDate(moment(`${current_day.year()}-${value.substr(0,2)}-${value.substr(2,2)}`))
        } else if(value.length == 6) {
          parsed_date = moment(`20${value.substr(4,2)}-${value.substr(0,2)}-${value.substr(2,2)}`)
        } else {
          parsed_date = lastMonthDate(moment(`${current_day.year()}-${current_day.month() + 1}-${value.split("/")[0]}`))
        }
      }
    }

    doSetInvoiceDate( parsed_date.isValid() ? parsed_date.format('MM/DD/YYYY') : null)
  }

  const lastMonthDate = (date) => {
    if (date.unix() > moment().unix()) {
      return date.month(moment().month() - 1)
    } else {
      return date
    }
  }

  const onBlurInvoiceDate = () => {
    if(invoice_date) {
      if(isFutureDate(invoice_date)) {
        setWarningMessage('The Date is in the Future, please check.')
        setShowWarning(true)
      } else if(isPastDate(invoice_date)) {
        setWarningMessage('The Date is older than 31 days, please check.')
        setShowWarning(true)
      } else {
        setWarningMessage(null)
        setShowWarning(false)
      }
    } else {
      setWarningMessage(null)
      setShowWarning(false)
    }
  }

  const isFutureDate = (date) => {
    return moment(date, 'MM/DD/YYYY').unix() > moment().subtract(1, 'days').unix()
  }

  const isPastDate = (date) => {
    return moment(date, 'MM/DD/YYYY').unix() < moment().subtract(31, 'days').unix()
  }


  return (
    <>
      <DatePicker
        placeholderText="Invoice Date"
        selected={invoice_date}
        value={invoice_date}
        onChange={onChangeInvoiceDate}
        onChangeRaw={(e) => onChangeRaw(e.target.value)}
        className={`invoice_date_input ${show_warning ? 'warning' : ''}`}
      />
      {(show_inline_warning == undefined || show_inline_warning == true) && warning_message && 
        <div className="alert alert-warning mt-2 p-2 px-3 mb-0" role="alert">
          {warning_message}
        </div>
      }
    </>
  )
}

export default Main;
